import { html } from "uhtml";
import * as appSignals from "../view-models/app-signals.js";
import { topNavigation } from "./partials/topNavigation.js";
import { bottomNavigation } from "./partials/bottomNavigation.js";
import { Customised } from "./custom-element.js";
import { setupEvents } from "../view-models/platform/events.js";
import { pageCount, pageData } from "../view-models/page-signals.js";
import "./ui-elements/cassis-contents.js";
import "./ui-elements/cassis-lib.js";
import "./ui-elements/cassis-settings.js";
import "./ui-elements/cassis-fullscreen.js";
import "./ui-elements/cassis-share.js";
import "./ui-elements/cassis-title.js";
import "./ui-elements/cassis-chapter-position.js";
import "./cassis-loading.js";
import "./cassis-pdf.js";
import "./ui-elements/cassis-toast.js";
import { closeIcon } from "./icons/close-icon.js";

export default class Reader extends Customised(HTMLElement) {
  static tagName = "cassis-reader";

  // Signals
  locale = appSignals.locale();
  pageNumber = appSignals.pageNumber();

  connectedCallback() {
    super.connectedCallback();
    setupEvents(this);
  }

  signals() {
    return {
      locale: appSignals.locale(),
      pageNumber: appSignals.pageNumber(),
      showNavigation: appSignals.showNavigation(),
      pages: pageData().pages,
      count: pageCount(),
    };
  }
  render({ locale, pageNumber, showNavigation, pages, count }) {
    return html`
			${topNavigation(locale, showNavigation)}
			<cassis-pdf></cassis-pdf><cassis-toast id="toast" class="toast-ui bottom" popover="auto"></cassis-toast>
			${bottomNavigation(locale, pageNumber, showNavigation, pages, count)}${closeIcon()}`;
  }
}

Reader.define();
